import { isAxiosError } from "axios";
import { TaskBannedErrors, TaskLimitErrors } from "../models/errors/apiErrors";
export class BaseApi {
	static baseUrl = "api/";
	static baseUrlV2 = "api/v2" as const;
}
export class ApiErrorHandlers {
	static LimitExceededError =
		"You have used all your available generations for this node on your plan. It will be recharged next month";
	static handleLimitError(e: unknown) {
		if (isAxiosError(e)) {
			const code = e.response?.data?.detail?.code;
			const code2 = e.response?.data?.data;
			if (
				e.response?.status === 400 &&
				(code === TaskLimitErrors.MidjourneyLimit ||
					code === TaskLimitErrors.GeneralTaskLimit ||
					code2 === TaskLimitErrors.MidjourneyRateLimit)
			) {
				throw ApiErrorHandlers.LimitExceededError;
			}
		}
	}
	static throwMessageFromError(e: unknown) {
		if (isAxiosError(e)) {
			const code =
				e.response?.data?.detail ||
				e.response?.data?.detail?.message ||
				e.response?.data?.detail?.code;
			if (code) {
				throw code;
			}
		}
	}
	static handleBannedWordsError(e: unknown) {
		if (isAxiosError(e)) {
			const code = e.response?.data?.detail;

			if (e.response?.status === 400 && code === TaskBannedErrors.ObsceneWords) {
				throw "Your prompt contains banned words";
			}
		}
	}
	static handleBannedWordsAndLimitError(e: unknown) {
		ApiErrorHandlers.handleLimitError(e);
		ApiErrorHandlers.handleBannedWordsError(e);
		ApiErrorHandlers.throwMessageFromError(e);
	}
}
